var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartDarkW24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.143 3.622a5.537 5.537 0 0 1 6.035 9.031L12 20.831l-8.178-8.178a5.537 5.537 0 1 1 7.83-7.83L12 5.17l.347-.347a5.5 5.5 0 0 1 1.796-1.201m2.12 1.178a3.94 3.94 0 0 0-2.785 1.154L12 7.432 10.52 5.954a3.937 3.937 0 1 0-5.568 5.568L12 18.569l7.046-7.047A3.937 3.937 0 0 0 16.262 4.8",
  clipRule: "evenodd"
})));
export default SvgIconHeartDarkW24;